import { render, staticRenderFns } from "./JobBankForm.vue?vue&type=template&id=448f51ea&"
import script from "./JobBankForm.vue?vue&type=script&lang=js&"
export * from "./JobBankForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports